import { useCallback } from 'react';
import { useAtom } from 'jotai';
import {
    acceptQuotePopupOpenAtom,
    acceptQuotePopupUrlSegmentAtom,
    acceptQuotePopupCustomerNameAtom,
    acceptQuotePopupCustomerEmailAtom,
} from '../states/accept-quote-popup-atoms';

/**
 * Custom hook for managing accept quote popup state and logic
 * @returns Object containing popup state and control functions
 */
export const useAcceptQuote = () => {
    const [isAcceptQuotePopupOpen, setIsAcceptQuotePopupOpen] = useAtom(
        acceptQuotePopupOpenAtom
    );
    const [currentUrlSegment, setCurrentUrlSegment] = useAtom(
        acceptQuotePopupUrlSegmentAtom
    );
    const [customerName, setCustomerName] = useAtom(
        acceptQuotePopupCustomerNameAtom
    );
    const [customerEmail, setCustomerEmail] = useAtom(
        acceptQuotePopupCustomerEmailAtom
    );

    const openPopup = useCallback(
        (urlSegment: string, name?: string, email?: string) => {
            setCurrentUrlSegment(urlSegment);
            setCustomerName(name || '');
            setCustomerEmail(email || '');
            setIsAcceptQuotePopupOpen(true);
        },
        [
            setCurrentUrlSegment,
            setCustomerName,
            setCustomerEmail,
            setIsAcceptQuotePopupOpen,
        ]
    );

    const closePopup = useCallback(() => {
        setIsAcceptQuotePopupOpen(false);
        setCurrentUrlSegment('');
        setCustomerName('');
        setCustomerEmail('');
    }, [
        setIsAcceptQuotePopupOpen,
        setCurrentUrlSegment,
        setCustomerName,
        setCustomerEmail,
    ]);

    return {
        isAcceptQuotePopupOpen,
        openPopup,
        closePopup,
        currentUrlSegment,
        customerName,
        customerEmail,
    };
};
